<div class="w-full flex flex-col gap-lg">
  <lib-calendar-toolbar
    [viewDate]="viewDate()"
    [view]="view()"
    [workingDays]="workingDays()!"
    [weekStartsOnNumber]="weekStartsOn()"
    (viewChange)="setView($event)"
    (viewDateChange)="handleChangeViewDate($event)"
    (closeOpenMonthViewDay)="closeOpenMonthViewDay()" />

  <!-- Calendar grid -->
  <div class="cal-container bg-white">
    @switch (view()) {
      @case (CalendarView.Month) {
        @if (customMonthCellTemplate(); as template) {
          <mwl-calendar-month-view
            [viewDate]="viewDate()"
            [events]="events()"
            [activeDayIsOpen]="activeDayIsOpen()"
            [cellTemplate]="template"
            (beforeViewRender)="beforeViewRender($event)" />
        }
      }

      @case (CalendarView.Week) {
        <mwl-calendar-week-view
          [viewDate]="viewDate()"
          [events]="events()"
          [weekStartsOn]="weekStartsOn()"
          [hourSegments]="1"
          [hourSegmentHeight]="segmentHeight()"
          [hourSegmentTemplate]="customWeekHourSegmentTemplate"
          [eventTemplate]="customWeekEventTemplate"
          (beforeViewRender)="beforeViewRender($event)" />
      }

      @case (CalendarView.Day) {
        <mwl-calendar-day-view
          [viewDate]="viewDate()"
          [events]="events()"
          [hourSegments]="1"
          [hourSegmentHeight]="segmentHeight()"
          [hourSegmentTemplate]="customWeekHourSegmentTemplate"
          [eventTemplate]="customWeekEventTemplate"
          (beforeViewRender)="beforeViewRender($event)" />
      }
    }
  </div>

  <!-- Custom Cell Template for Month View: Customized & No Badge Total -->
  <lib-month-cell-template
    [viewDate]="viewDate()"
    (setView)="setView($event)"
    (viewDateChange)="handleChangeViewDate($event)"
    (eventClick)="eventClick.emit($event)"
    [eventActionsTemplate]="eventActionsTemplate()" />

  <ng-template
    #customWeekHourSegmentTemplate
    let-segment="segment"
    let-locale="locale"
    let-segmentHeight="segmentHeight"
    let-isTimeLabel="isTimeLabel"
    let-daysInWeek="daysInWeek"
    let-index="index">
    <div
      [style.height.px]="segmentHeight"
      [class.cal-hour-start]="segment.isStart"
      [class.bg-white]="segment.isStart"
      [class.cal-after-hour-start]="!segment.isStart"
      [class]="
        'cal-hour-segment flex items-center justify-center h-full w-full transition-colors hover:bg-neutral-50 -scroll-mt-200 ' +
        (segment.date | calendarSegmentBg: workingDays()!) +
        ' ' +
        (segment.cssClass || '')
      ">
      @if (isTimeLabel) {
        <div
          class="cal-time text-xs font-semibold text-neutral-500 p-xs select-none">
          {{
            segment.displayDate
              | calendarDate
                : (daysInWeek === 1 ? 'dayViewHour' : 'weekViewHour')
                : locale
          }}
        </div>
      }
    </div>
  </ng-template>

  <ng-template #customWeekEventTemplate let-weekEvent="weekEvent">
    @let event = weekEvent.event;
    @let meta = event.meta;
    @if (event) {
      <div class="relative h-full" [id]="meta.elementId">
        <button
          type="button"
          class="flex flex-col justify-between p-sm rounded-sm w-[calc(100%-0.25rem)] h-full text-start"
          [class.bg-primary-100]="!meta.color"
          [class.bg-destructive-100]="meta.color === CALENDAR_EVENT_COLOR.RED"
          [class.bg-neutral-100]="meta.color === CALENDAR_EVENT_COLOR.GRAY"
          (click)="eventClick.emit(event)"
          [title]="event.title">
          <div class="flex items-center gap-x-sm">
            @if (meta.source_type === CALENDAR_EVENT_SOURCE_TYPE.PROJECT) {
              <lib-repeat-icon
                [iconClass]="
                  'size-3 ' +
                  (meta.color === CALENDAR_EVENT_COLOR.RED
                    ? 'text-destructive-500'
                    : meta.color === CALENDAR_EVENT_COLOR.GRAY
                      ? 'text-neutral-500'
                      : 'text-primary-500')
                " />
            } @else {
              <lib-calendar-filled-icon
                [iconClass]="
                  'size-3 ' +
                  (meta.color === CALENDAR_EVENT_COLOR.RED
                    ? 'text-destructive-500'
                    : meta.color === CALENDAR_EVENT_COLOR.GRAY
                      ? 'text-neutral-500'
                      : 'text-primary-500')
                " />
            }

            <div
              class="font-semibold text-xs text-neutral-900 truncate min-w-0 max-w-[calc(100%-1.25rem)]">
              {{ event.title }}
            </div>
          </div>

          <ng-container
            [ngTemplateOutlet]="assigneeTemplate"
            [ngTemplateOutletContext]="{ event: event }" />
        </button>

        @if (isSelectedOccurrence(event)) {
          <lib-calendar-event-modal
            (closeEventDetails)="closeEventDetails()"
            [eventActionsTemplate]="eventActionsTemplate()" />
        }
      </div>
    }
  </ng-template>

  <ng-template #assigneeTemplate let-event="event">
    @let diffMinutes = (event.end.getTime() - event.start.getTime()) / 60000;
    @let assignees = event.meta?.assignees || [];
    @if (diffMinutes > 59) {
      <div
        libCalendarEventNeighbors
        [event]="event"
        [events]="events()"
        [calendarView]="view()"
        [acceptableNeighbors]="1">
        <lib-user-dropdown-view
          [userTableList]="assignees"
          [userCount]="assignees.length"
          [userDropdownList]="assignees"
          [totalDropdownCount]="assignees.length"
          [enableDropdownIcon]="false"
          [headerListLabel]="'dropdown_search_find_assignees_label' | transloco"
          [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
          [searchPlaceholder]="'search_by_name_placeholder' | transloco"
          [noSearchResultLabel]="'no_search_result_label' | transloco"
          [enableLocalSearch]="true"
          [containerRef]="event.meta.elementId" />
      </div>
    }
  </ng-template>
</div>
